(() => {
  if (!['/policies/refund-policy', '/pages/politica-retur', '/pages/politica-de-retur-și-schimb'].includes(decodeURI(window.location.pathname).replace(/\/$/, ''))) return;

  const loadPolicy = () => {
    const body = document.querySelector('.shopify-policy__body .rte');
    if (!body) return;

    fetch('/apps/inventorypal-feeds/politica/retur', {
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Return policy request failed: ${response.status}`);
        return response.json();
      })
      .then((policy) => {
        const rate = Number(policy?.standardShippingAmount);
        const threshold = Number(policy?.freeShippingThreshold);
        if (!Number.isFinite(rate) || rate <= 0 || !Number.isFinite(threshold) || threshold <= 0) return;
        const lei = (value) => `${new Intl.NumberFormat('ro-RO', { maximumFractionDigits: 2 }).format(value)} lei`;
        body.querySelectorAll('[data-return-policy-rate]').forEach((element) => { element.textContent = lei(rate); });
        body.querySelectorAll('[data-return-policy-threshold]').forEach((element) => { element.textContent = lei(threshold); });
        body.dataset.inventorypalReturnPolicy = 'dynamic';
      })
      .catch(() => {});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadPolicy, { once: true });
  } else {
    loadPolicy();
  }
})();
